import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/style/variables.module.scss";

const root = ReactDOM.createRoot(document.getElementById("root")); // Yeni API

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
